import React, { useEffect, useState } from 'react';
import { Leaf, Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing-cta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setMobileMenuOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <div className="flex justify-between items-center" data-id="element-140">
          {/* Logo */}
          <div className="flex items-center gap-2" data-id="element-141">
            <div className="bg-sage/20 p-2 rounded-full" data-id="element-142">
              <Leaf className="h-6 w-6 text-sage-dark" data-id="element-143" />
            </div>
            <span className="font-serif text-xl font-bold text-forest tracking-tight" data-id="element-144">
              PequeSalud <span className="text-terracotta" data-id="element-145">Natural</span>
            </span>
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:block" data-id="element-146">
            <Button variant="primary" size="sm" onClick={scrollToPricing} data-id="element-147">
              $6.39 — Obtener Guía
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-148">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2 text-forest hover:bg-sage/10 rounded-full" aria-label="Menu" data-id="element-149">
              {mobileMenuOpen ? <X className="h-6 w-6" data-id="element-150" /> : <Menu className="h-6 w-6" data-id="element-151" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-152">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-cream border-t border-sage/10 overflow-hidden" data-id="element-153">
            <div className="px-4 py-6 space-y-4 flex flex-col items-center" data-id="element-154">
              <span className="text-forest/80 text-sm font-medium" data-id="element-155">
                Guía digital de apoyo natural
              </span>
              <Button variant="primary" fullWidth onClick={scrollToPricing} data-id="element-156">
                Obtener por $6.39
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}